import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const MONTHS = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];

const lastDay = (y, m) => new Date(y, m, 0).getDate();

export const PeriodFilter = ({ range, setRange }) => {
  const now = new Date();
  const [mode, setMode] = React.useState("all");
  const [year, setYear] = React.useState(String(now.getFullYear()));
  const [month, setMonth] = React.useState(String(now.getMonth() + 1));

  const apply = (m, y = year, mo = month, custom = range) => {
    setMode(m);
    if (m === "all") setRange({ start: "", end: "" });
    else if (m === "year") setRange({ start: `${y}-01-01`, end: `${y}-12-31` });
    else if (m === "month")
      setRange({
        start: `${y}-${String(mo).padStart(2, "0")}-01`,
        end: `${y}-${String(mo).padStart(2, "0")}-${String(lastDay(Number(y), Number(mo))).padStart(2, "0")}`,
      });
    else setRange(custom);
  };

  const years = Array.from({ length: 6 }, (_, i) => now.getFullYear() - i);

  return (
    <div className="glass rounded-2xl p-5 md:p-6" data-testid="period-filter">
      <div className="flex flex-wrap items-center gap-2">
        {[
          { k: "all", l: "Semua" },
          { k: "year", l: "Per Tahun" },
          { k: "month", l: "Per Bulan" },
          { k: "custom", l: "Per Tanggal" },
        ].map((o) => (
          <Button
            key={o.k}
            data-testid={`filter-mode-${o.k}`}
            onClick={() => apply(o.k)}
            className={`rounded-full h-9 px-4 text-xs uppercase tracking-wider font-semibold ${
              mode === o.k
                ? "bg-blue-600 hover:bg-blue-500 text-white"
                : "bg-slate-800/60 hover:bg-slate-700/70 text-slate-300 border border-white/10"
            }`}
          >
            {o.l}
          </Button>
        ))}
      </div>

      {(mode === "year" || mode === "month") && (
        <div className="mt-5 flex flex-wrap gap-3">
          {mode === "month" && (
            <select
              data-testid="filter-month-select"
              value={month}
              onChange={(e) => {
                setMonth(e.target.value);
                apply("month", year, e.target.value);
              }}
              className="h-11 rounded-xl bg-slate-900/70 border border-white/10 px-4 text-sm outline-none focus:ring-2 focus:ring-blue-500"
            >
              {MONTHS.map((m, i) => (
                <option key={m} value={i + 1}>{m}</option>
              ))}
            </select>
          )}
          <select
            data-testid="filter-year-select"
            value={year}
            onChange={(e) => {
              setYear(e.target.value);
              apply(mode, e.target.value, month);
            }}
            className="h-11 rounded-xl bg-slate-900/70 border border-white/10 px-4 text-sm outline-none focus:ring-2 focus:ring-blue-500"
          >
            {years.map((y) => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
        </div>
      )}

      {mode === "custom" && (
        <div className="mt-5 flex flex-wrap items-center gap-3">
          <Input
            data-testid="filter-start-date"
            type="date"
            value={range.start}
            onChange={(e) => setRange({ ...range, start: e.target.value })}
            className="h-11 w-auto bg-slate-900/70 border-white/10"
          />
          <span className="text-slate-500 text-sm">s/d</span>
          <Input
            data-testid="filter-end-date"
            type="date"
            value={range.end}
            onChange={(e) => setRange({ ...range, end: e.target.value })}
            className="h-11 w-auto bg-slate-900/70 border-white/10"
          />
        </div>
      )}
    </div>
  );
};
